import { useLocation } from 'react-router-dom';

import { LogOut, Monitor, Moon, Sun, SunMoon } from 'lucide-react';

import { auth } from '@/api/firebase';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useMainContext } from '@/context/main-context';
import { getMenuList } from '@/lib/menu-list';
import { useTheme } from '@/provider/ThemeProvider';
import { signOut } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { Avatar, AvatarFallback } from '../ui/avatar';

export function Menu({ isOpen }) {
  const { teacherData } = useMainContext();
  const { setTheme } = useTheme();
  let location = useLocation();
  const menuList = getMenuList(location.pathname);

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        console.log('Signed out successfully');
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === 'd') {
        event.preventDefault();
        setTheme('dark');
      }
      if (event.ctrlKey && event.key === 'f') {
        event.preventDefault();
        setTheme('light');
      }
      if (event.ctrlKey && event.key === 'g') {
        event.preventDefault();
        setTheme('system');
      }
      if (event.ctrlKey && event.key === 'q') {
        event.preventDefault();
        setOpenAlert(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const [initials, setInitials] = useState('');

  useEffect(() => {
    if (!teacherData?.fullName) return;

    const nameParts = teacherData.fullName.split(' ');

    if (nameParts.length === 1) {
      setInitials(nameParts[0].slice(0, 2).toUpperCase());
    } else {
      setInitials((nameParts[0][0] + nameParts[1][0]).toUpperCase());
    }
  }, [teacherData?.fullName]);

  return (
    <TooltipProvider disableHoverableContent>
      <DropdownMenu>
        <Tooltip delayDuration={100}>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button
                onClick={() => {}}
                variant="secondary"
                className="h-10 w-10 p-1 md:pl-1 md:pr-4 md:w-fit rounded-full flex items-center gap-2"
              >
                <Avatar
                  title={teacherData?.fullName}
                  key={teacherData.id}
                  className="w-8 h-8 shadow border border-border dark:border-white/20 bg-muted"
                >
                  <AvatarFallback className="text-xs bg-white dark:bg-muted">
                    {initials}
                  </AvatarFallback>
                </Avatar>

                <span className="hidden md:block">{teacherData?.fullName}</span>
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          {isOpen === false && (
            <TooltipContent side="right">Sozlamalar</TooltipContent>
          )}
        </Tooltip>
        <DropdownMenuContent className="w-56">
          <DropdownMenuLabel>Mening hisobim</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            {/* <DropdownMenuItem>
                    <Settings className="mr-2 h-4 w-4" />
                    <span>Settings</span>
                    <DropdownMenuShortcut>⌘S</DropdownMenuShortcut>
                  </DropdownMenuItem> */}
            <DropdownMenuSub>
              <DropdownMenuSubTrigger>
                <SunMoon className="mr-2 h-4 w-4" />
                <span>Mavzu</span>
              </DropdownMenuSubTrigger>
              <DropdownMenuPortal>
                <DropdownMenuSubContent className="w-40">
                  <DropdownMenuItem onClick={() => setTheme('light')}>
                    <Sun className="mr-2 h-4 w-4" />
                    <span>Kunduzgi</span>
                    <DropdownMenuShortcut>⌘F</DropdownMenuShortcut>
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => setTheme('dark')}>
                    <Moon className="mr-2 h-4 w-4" />
                    <span>Tungi</span>
                    <DropdownMenuShortcut>⌘D</DropdownMenuShortcut>
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => setTheme('system')}>
                    <Monitor className="mr-2 h-4 w-4" />
                    <span>Sistema</span>
                    <DropdownMenuShortcut>⌘G</DropdownMenuShortcut>
                  </DropdownMenuItem>
                </DropdownMenuSubContent>
              </DropdownMenuPortal>
            </DropdownMenuSub>
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleLogout}>
            <LogOut className="mr-2 h-4 w-4" />
            <span>Tizimdan chiqish</span>
            <DropdownMenuShortcut>⇧⌘Q</DropdownMenuShortcut>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </TooltipProvider>
  );
}
